var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResponsiveLine } from '@nivo/line';
import { useTheme } from 'styled-components';
import { ChartWrapper, StyledDiv } from './styles';
import { Text } from '../../../Text';
import { getLineOptionsByVariant } from '../../lineOptions';
export var SimpleChart = function (_a) {
  var chartLineForContribution = _a.chartLineForContribution,
    chartLineForProjection = _a.chartLineForProjection,
    xAxisFormatter = _a.xAxisFormatter,
    xFormat = _a.xFormat,
    yAxisFormatter = _a.yAxisFormatter,
    yFormat = _a.yFormat;
  var theme = useTheme();
  var labelStart = new Date(chartLineForContribution.data[0].x).getFullYear();
  var labelEnd = new Date(chartLineForContribution.data[chartLineForContribution.data.length - 1].x).getFullYear();
  return _jsxs(ChartWrapper, {
    children: [_jsx(ResponsiveLine, __assign({}, getLineOptionsByVariant('simple', {
      chartLineForContribution: chartLineForContribution,
      chartLineForProjection: chartLineForProjection,
      theme: theme,
      xAxisFormatter: xAxisFormatter,
      xFormat: xFormat,
      yAxisFormatter: yAxisFormatter,
      yFormat: yFormat
    }))), _jsxs(StyledDiv, {
      children: [_jsx(Text, {
        el: "span",
        styleName: "bodySmall",
        children: labelStart
      }), _jsx(Text, {
        el: "span",
        styleName: "bodySmall",
        children: labelEnd
      })]
    })]
  });
};